import React from 'react';
import { MenuDropdown as Dropdown, MenuItem } from '../../styles/ColumnMenu.styles';

const MenuDropdown = ({ onArchiveAll, onDeleteClick, onExportList, setIsOpen }) => {
    const handleArchiveAll = () => {
        onArchiveAll();
        setIsOpen(false);
    };

    const handleExportList = () => {
        if (onExportList) onExportList();
        setIsOpen(false);
    };

    return (
        <Dropdown>
            <MenuItem onClick={handleArchiveAll}>
                Archive all cards in this list
            </MenuItem>
            <MenuItem onClick={handleExportList}>
                Export list as JSON
            </MenuItem>
            <MenuItem
                onClick={onDeleteClick}
                isDelete
            >
                Delete list
            </MenuItem>
        </Dropdown>
    );
};

export default MenuDropdown;